"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _annotation = require("../actions/annotation");

var _comments = require("../actions/comments");

var _context = require("../actions/context");

var _constants = require("../constants");

var _AppContext = _interopRequireDefault(require("../context/AppContext"));

var _CallbackContext = _interopRequireDefault(require("../context/CallbackContext"));

var _useIngest = _interopRequireDefault(require("./useIngest"));

var _reducers = require("../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ANNOTATION_TYPES = ['highlight', 'strikethrough', 'replace', 'insert', 'draw', 'pin'];
/**
 * useComments hook to expose comments api. Must be used under CommentsProvider.
 * @param {Function} onCommentsApiUpdate - callback for when a change in API is detected
 * @returns {Object} - API to generate changes to commenting.
 */

function useComments(onCommentsApiUpdate) {
  var manualDisableRef = (0, _react.useRef)({
    isManuallyDisabled: false
  });
  var appContext = (0, _react.useContext)(_AppContext.default);
  var callbackContext = (0, _react.useContext)(_CallbackContext.default);
  var assetData = appContext.assetData,
      cacheComments = appContext.cacheComments,
      asset = appContext.asset.asset;
  var nodeId = assetData.nodeId;
  var ccxIngest = (0, _useIngest.default)();
  var store = (0, _reducers.useStore)();
  var dispatch = (0, _reducers.useDispatch)();
  var showCommentPromiseRef = (0, _react.useRef)();
  var handleShowComment = (0, _react.useCallback)(function (cmtId, fromCommentFirst, resolve, reject) {
    var _store$getState$ = store.getState()["".concat(_constants.PREFIX, ":comments")],
        comments = _store$getState$.comments,
        showResolvedComments = _store$getState$.showResolvedComments;

    if (comments) {
      if (comments && comments.length) {
        var matchingComment;
        var matchingParent;
        comments.some(function (comment) {
          if (comment.id === cmtId) {
            matchingComment = comment;
          } else if (comment.replies && comment.replies.length) {
            comment.replies.some(function (reply) {
              if (reply.id === cmtId) {
                matchingComment = reply;
                matchingParent = comment;
                return true;
              }

              return false;
            });
          }

          return !!matchingComment;
        });

        if (matchingComment) {
          if ((!matchingParent && matchingComment.status !== 'open' || matchingParent && matchingParent.status !== 'open') && !showResolvedComments || (!matchingParent && matchingComment.status === 'open' || matchingParent && matchingParent.status === 'open') && showResolvedComments) {
            dispatch((0, _comments.toggleResolved)());
          }

          if (matchingParent) {
            dispatch((0, _comments.commentsToggleReply)(matchingParent.id));
          }

          if (matchingComment.unmapped) {
            dispatch((0, _context.contextSetUnmappedView)(true));
            resolve({});
          } else {
            var _ref, _ref$target, _ref$target$selector, _ref$target$selector$, _ref2, _ref2$target, _ref2$target$selector;

            if (!fromCommentFirst) {
              dispatch((0, _context.contextSetUnmappedView)(false));
            }

            var _nodeId = (_ref = matchingComment || matchingParent) === null || _ref === void 0 ? void 0 : (_ref$target = _ref.target) === null || _ref$target === void 0 ? void 0 : (_ref$target$selector = _ref$target.selector) === null || _ref$target$selector === void 0 ? void 0 : (_ref$target$selector$ = _ref$target$selector.node) === null || _ref$target$selector$ === void 0 ? void 0 : _ref$target$selector$.id;

            var sectionId = (_ref2 = matchingComment || matchingParent) === null || _ref2 === void 0 ? void 0 : (_ref2$target = _ref2.target) === null || _ref2$target === void 0 ? void 0 : (_ref2$target$selector = _ref2$target.selector) === null || _ref2$target$selector === void 0 ? void 0 : _ref2$target$selector.sectionId;
            resolve({
              nodeId: _nodeId,
              sectionId: sectionId
            });
          }

          dispatch((0, _context.contextSetShowCommentId)(matchingComment.id));
        } else {
          reject(new Error('unable to find requested comment'));
        }
      } else {
        reject(new Error('unable to find requested comment'));
      }
    } else {
      reject(new Error('unable to find requested comment'));
    }
  }, [dispatch, store]);
  (0, _react.useEffect)(function () {
    if (asset && showCommentPromiseRef.current) {
      var _showCommentPromiseRe = showCommentPromiseRef.current,
          args = _showCommentPromiseRe.args,
          handlers = _showCommentPromiseRe.handlers;
      var cmtId = args.cmtId,
          fromCommentFirst = args.fromCommentFirst;
      var resolve = handlers.resolve,
          reject = handlers.reject;
      handleShowComment(cmtId, fromCommentFirst, resolve, reject);
      showCommentPromiseRef.current = undefined;
    }
  }, [asset, handleShowComment]);
  var getComments = (0, _react.useCallback)(function () {
    return store.getState()["".concat(_constants.PREFIX, ":comments")].comments;
  }, [store]);
  var registerAnnotationSection = (0, _react.useCallback)(function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'root';
    return dispatch((0, _context.contextRegisterSectionId)(id, true));
  }, [dispatch]);
  var unregisterAnnotationSection = (0, _react.useCallback)(function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'root';
    return dispatch((0, _context.contextRegisterSectionId)(id, false));
  }, [dispatch]);
  var endViewingUnmapped = (0, _react.useCallback)(function () {
    return dispatch((0, _context.contextSetUnmappedView)(false));
  }, [dispatch]);
  var minimizeCommentsList = (0, _react.useCallback)(function () {
    return dispatch((0, _context.contextSetCommentsListMinimized)(true));
  }, [dispatch]);

  var _remapCommentNodes = (0, _react.useCallback)(function (mappingData) {
    return dispatch((0, _comments.remapCommentNodes)(mappingData));
  }, [dispatch]);

  var highlightComment = (0, _react.useCallback)(function (commentId) {
    return dispatch((0, _annotation.annotationSetHoveredAnnotation)(commentId));
  }, [dispatch]);
  var unhighlightComment = (0, _react.useCallback)(function () {
    return dispatch((0, _annotation.annotationSetHoveredAnnotation)(undefined));
  }, [dispatch]);
  var removePendingAnnotation = (0, _react.useCallback)(function () {
    dispatch((0, _context.contextSaveAnnotationLocation)());
    dispatch((0, _context.contextSetAnnotationMode)());
  }, [dispatch]);

  var _batchCommentUpdate = (0, _react.useCallback)(function (mappingData, overrideAssetId) {
    return dispatch((0, _comments.batchCommentUpdate)(overrideAssetId || assetData.id, mappingData, cacheComments, !overrideAssetId || overrideAssetId === assetData.id));
  }, [assetData, cacheComments, dispatch]);

  var endAnnotating = (0, _react.useCallback)(function () {
    var newAnnotationType = store.getState()["".concat(_constants.PREFIX, ":context")].newAnnotationType;
    dispatch((0, _context.contextSetAnnotationMode)(false));
    ccxIngest.fireEvent({
      event: {
        subcategory: "".concat(newAnnotationType, "-comment"),
        type: 'keystroke',
        subtype: 'pin-mode-exit'
      }
    });
  }, [store, dispatch, ccxIngest]);
  var showComment = (0, _react.useCallback)(function (cmtId, fromCommentFirst) {
    return new Promise(function (resolve, reject) {
      if (asset) {
        handleShowComment(cmtId, fromCommentFirst, resolve, reject);
      } else {
        if (showCommentPromiseRef.current) {
          var _reject = showCommentPromiseRef.current.handlers.reject;

          _reject(new Error('showComment called again before previous call has resolved'));
        }

        showCommentPromiseRef.current = {
          args: {
            cmtId: cmtId,
            fromCommentFirst: fromCommentFirst
          },
          handlers: {
            resolve: resolve,
            reject: reject
          }
        };
      }
    });
  }, [asset, handleShowComment]);
  var createPendingAnnotation = (0, _react.useCallback)(function (payload) {
    var boundingBox = payload.boundingBox,
        hostColor = payload.color,
        hostNodeId = payload.nodeId,
        points = payload.points,
        sectionId = payload.sectionId,
        hostType = payload.type;
    var _store$getState$2 = store.getState()["".concat(_constants.PREFIX, ":context")],
        reduxColor = _store$getState$2.annotationColor,
        reduxType = _store$getState$2.newAnnotationType;
    var newNodeId = hostNodeId || nodeId;
    var annotationColor = hostColor || reduxColor;
    var newAnnotationType = hostType || reduxType;
    var annotationData;

    if (hostColor && !_constants.ANNOTATION_COLOR_PALETE.find(function (curColor) {
      return curColor.hex === hostColor;
    })) {
      console.warn("Annotation color ".concat(hostColor, " is unsupported. Falling back to ").concat(reduxColor));
      annotationColor = reduxColor;
    }

    if (hostType && !ANNOTATION_TYPES.find(function (curAnnotationType) {
      return curAnnotationType === hostType;
    })) {
      console.warn("Annotation type ".concat(hostType, " is unsupported. Falling back to ").concat(reduxType));
      newAnnotationType = reduxType;
    }

    if (newAnnotationType === 'highlight' || newAnnotationType === 'strikethrough' || newAnnotationType === 'replace') {
      var newPoints = points.concat([]);
      newPoints = [];
      points.forEach(function (line) {
        var newLine = [];
        var lineLeft = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
          return point.x;
        })));
        var lineTop = Math.min.apply(Math, _toConsumableArray(line.map(function (point) {
          return point.y;
        })));
        var lineRight = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
          return point.x;
        })));
        var lineBottom = Math.max.apply(Math, _toConsumableArray(line.map(function (point) {
          return point.y;
        })));
        newLine.push({
          x: lineLeft,
          y: lineBottom
        }, {
          x: lineRight,
          y: lineBottom
        }, {
          x: lineLeft,
          y: lineTop
        }, {
          x: lineRight,
          y: lineTop
        });
        newPoints.push(newLine);
      });
      annotationData = {
        subtype: newAnnotationType,
        boundingBox: [boundingBox.left, boundingBox.bottom, boundingBox.right, boundingBox.top],
        inkList: newPoints,
        sectionId: sectionId,
        strokeColor: annotationColor
      };
    } else if (newAnnotationType === 'insert') {
      annotationData = {
        subtype: newAnnotationType,
        boundingBox: [points.x - 13, points.y, points.x, points.y - 18],
        // remove 13px (element width / 2 = 11 + extra 2 px because of whitespace in SVG) from left to center annotation element & remove 18px from bottom to align bottom
        sectionId: sectionId,
        strokeColor: annotationColor,
        noteX: points.x,
        noteY: points.y
      };
    } else if (newAnnotationType === 'draw') {
      annotationData = {
        subtype: 'shape',
        boundingBox: [boundingBox.left, boundingBox.bottom, boundingBox.right, boundingBox.top],
        inkList: points,
        sectionId: sectionId,
        strokeColor: annotationColor
      };
    } else if (newAnnotationType === 'pin') {
      annotationData = {
        subtype: 'note',
        sectionId: sectionId,
        strokeColor: annotationColor,
        noteX: points.x,
        noteY: points.y
      };
    }

    dispatch((0, _context.contextSaveAnnotationLocation)(annotationData, newNodeId));
    dispatch((0, _context.contextSetAnnotationMode)(false, 'root', false, newAnnotationType));

    if (annotationColor !== reduxColor) {
      dispatch((0, _context.contextSaveAnnotationColor)(annotationColor));
    }

    if (nodeId !== newNodeId) {
      callbackContext.onNodeChange(newNodeId);
    }
  }, [store, dispatch, nodeId, callbackContext]);
  var enableComments = (0, _react.useCallback)(function (evt) {
    if (!evt || !evt.type || evt.type !== 'focus') {
      manualDisableRef.current.isManuallyDisabled = false;
    }

    if (asset && !manualDisableRef.current.isManuallyDisabled) {
      asset.checkForUpdates();
    }
  }, [asset]);
  var disableComments = (0, _react.useCallback)(function (evt) {
    if (!evt || !evt.type || evt.type !== 'blur') {
      manualDisableRef.current.isManuallyDisabled = true;
    }

    if (asset) {
      asset.disableUpdates();
    }
  }, [asset]);
  var result = (0, _react.useMemo)(function () {
    return {
      batchCommentUpdate: _batchCommentUpdate,
      createPendingAnnotation: createPendingAnnotation,
      disableComments: disableComments,
      enableComments: enableComments,
      endAnnotating: endAnnotating,
      endViewingUnmapped: endViewingUnmapped,
      getComments: getComments,
      highlightComment: highlightComment,
      minimizeCommentsList: minimizeCommentsList,
      registerAnnotationSection: registerAnnotationSection,
      remapCommentNodes: _remapCommentNodes,
      removePendingAnnotation: removePendingAnnotation,
      showComment: showComment,
      unhighlightComment: unhighlightComment,
      unregisterAnnotationSection: unregisterAnnotationSection
    };
  }, [_batchCommentUpdate, createPendingAnnotation, disableComments, enableComments, endAnnotating, endViewingUnmapped, getComments, highlightComment, minimizeCommentsList, registerAnnotationSection, _remapCommentNodes, removePendingAnnotation, showComment, unhighlightComment, unregisterAnnotationSection]);
  (0, _react.useEffect)(function () {
    if (onCommentsApiUpdate) {
      onCommentsApiUpdate();
    }
  }, [result, onCommentsApiUpdate]);
  return result;
}

var _default = useComments;
exports.default = _default;